'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { Button, Drawer, FilterChip, IconButton, Separator } from '@/shared/components/ui';
import { FeatherActivity, FeatherAlertCircle, FeatherFlame, FeatherSnowflake, FeatherTag, FeatherThermometer, FeatherX } from '@subframe/core';
import { fetchNegociacaoSituacoes, selectNegociacoesSituacoes, selectNegociacoesSituacoesLoaded } from '../store';
import type { PeriodoValor } from '@/shared/types/filtroPeriodo';
import type { NegociacoesFilters } from '../types/negociacoesUiTypes';
import { PeriodoDrawerSection } from './PeriodoDrawerSection';
import { getTemperatureMeta, pendencyOptions, statusOptions, temperatureOptions } from '../utils';
interface NegotiacoesFiltersDrawerProps {
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  tempFilters: NegociacoesFilters;
  hasTempFilters: boolean;
  toggleTempFilterValue: (category: keyof NegociacoesFilters, value: string) => void;
  selectAllTempInCategory: (category: keyof NegociacoesFilters, options: string[]) => void;
  clearTempFilters: () => void;
  applyFilters: () => void;

  /** Ausente na lista de lotes, que não filtra por período. */
  tempPeriodo?: PeriodoValor;
  setTempPeriodo?: (valor: PeriodoValor) => void;
}
export function NegotiacoesFiltersDrawer(t0) {
  const $ = _c(101);
  const {
    isOpen,
    onOpenChange,
    tempFilters,
    hasTempFilters,
    toggleTempFilterValue,
    selectAllTempInCategory,
    clearTempFilters,
    applyFilters,
    tempPeriodo,
    setTempPeriodo
  } = t0;
  const dispatch = useAppDispatch();
  const situacoesOptions = useAppSelector(selectNegociacoesSituacoes);
  const situacoesLoaded = useAppSelector(selectNegociacoesSituacoesLoaded);
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== isOpen || $[2] !== situacoesLoaded) {
    t1 = () => {
      if (isOpen && !situacoesLoaded) {
        dispatch(fetchNegociacaoSituacoes());
      }
    };
    t2 = [dispatch, isOpen, situacoesLoaded];
    $[0] = dispatch;
    $[1] = isOpen;
    $[2] = situacoesLoaded;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const getTemperatureIcon = _temp;
  const buildSelectAllLabel = _temp2;
  let t3;
  if ($[5] !== selectAllTempInCategory || $[6] !== tempFilters) {
    t3 = (category, options) => {
      if (tempFilters[category].length === options.length) {
        selectAllTempInCategory(category, []);
        return;
      }
      selectAllTempInCategory(category, options);
    };
    $[5] = selectAllTempInCategory;
    $[6] = tempFilters;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const toggleSelectAll = t3;
  let t4;
  if ($[8] !== situacoesOptions) {
    t4 = situacoesOptions.map(_temp3);
    $[8] = situacoesOptions;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const situacaoIdOptions = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="text-heading-3 font-heading-3 text-default-font">Filtros</h2>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherX />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onOpenChange) {
    t7 = <div className="flex items-center justify-between border-b border-neutral-200 px-6 py-4">{t5}<IconButton variant="neutral-tertiary" icon={t6} onClick={() => onOpenChange(false)} /></div>;
    $[12] = onOpenChange;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== setTempPeriodo || $[15] !== tempPeriodo) {
    t8 = tempPeriodo && setTempPeriodo && <><PeriodoDrawerSection valor={tempPeriodo} onChange={setTempPeriodo} /><Separator /></>;
    $[14] = setTempPeriodo;
    $[15] = tempPeriodo;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex items-center gap-2"><FeatherActivity className="text-brand-600 h-4 w-4" /><span className="text-body-bold font-body-bold text-default-font">Status</span></div>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== toggleSelectAll) {
    t10 = () => toggleSelectAll("status", statusOptions);
    $[18] = toggleSelectAll;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = buildSelectAllLabel(tempFilters.status.length, statusOptions.length);
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <div className="flex items-center justify-between">{t9}<Button variant="neutral-tertiary" size="small" onClick={t10}>{t11}</Button></div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== tempFilters.status || $[24] !== toggleTempFilterValue) {
    t13 = statusOptions.map(status => <FilterChip key={status} active={tempFilters.status.includes(status)} onClick={() => toggleTempFilterValue("status", status)}>{status}</FilterChip>);
    $[23] = tempFilters.status;
    $[24] = toggleTempFilterValue;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <div className="flex flex-wrap gap-2">{t13}</div>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t14) {
    t15 = <div className="flex flex-col gap-3">{t12}{t14}</div>;
    $[28] = t12;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Separator />;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex items-center gap-2"><FeatherTag className="text-brand-600 h-4 w-4" /><span className="text-body-bold font-body-bold text-default-font">Situação</span></div>;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== situacaoIdOptions || $[34] !== toggleSelectAll) {
    t18 = () => toggleSelectAll("situacao", situacaoIdOptions);
    $[33] = situacaoIdOptions;
    $[34] = toggleSelectAll;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const t19 = situacoesOptions.length === 0;
  const t20 = buildSelectAllLabel(tempFilters.situacao.length, situacoesOptions.length);
  let t21;
  if ($[36] !== t18 || $[37] !== t19 || $[38] !== t20) {
    t21 = <div className="flex items-center justify-between">{t17}<Button variant="neutral-tertiary" size="small" onClick={t18} disabled={t19}>{t20}</Button></div>;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== situacoesOptions || $[41] !== tempFilters.situacao || $[42] !== toggleTempFilterValue) {
    t22 = situacoesOptions.length === 0 ? <span className="text-caption font-caption text-subtext-color">Nenhuma situação disponível</span> : situacoesOptions.map(situacao => <FilterChip key={situacao.id} active={tempFilters.situacao.includes(situacao.id)} onClick={() => toggleTempFilterValue("situacao", situacao.id)}>{situacao.label}</FilterChip>);
    $[40] = situacoesOptions;
    $[41] = tempFilters.situacao;
    $[42] = toggleTempFilterValue;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t22) {
    t23 = <div className="flex flex-wrap gap-2">{t22}</div>;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t21 || $[47] !== t23) {
    t24 = <div className="flex flex-col gap-3">{t21}{t23}</div>;
    $[46] = t21;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Separator />;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="flex items-center gap-2"><FeatherThermometer className="text-brand-600 h-4 w-4" /><span className="text-body-bold font-body-bold text-default-font">Temperatura</span></div>;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== toggleSelectAll) {
    t27 = () => toggleSelectAll("temperature", temperatureOptions);
    $[51] = toggleSelectAll;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  const t28 = buildSelectAllLabel(tempFilters.temperature.length, temperatureOptions.length);
  let t29;
  if ($[53] !== t27 || $[54] !== t28) {
    t29 = <div className="flex items-center justify-between">{t26}<Button variant="neutral-tertiary" size="small" onClick={t27}>{t28}</Button></div>;
    $[53] = t27;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== tempFilters.temperature || $[57] !== toggleTempFilterValue) {
    t30 = temperatureOptions.map(temp => {
      const meta_0 = getTemperatureMeta(temp);
      return <FilterChip key={temp} active={tempFilters.temperature.includes(temp)} onClick={() => toggleTempFilterValue("temperature", temp)} icon={<span className={meta_0.colorClass}>{getTemperatureIcon(temp)}</span>}>{temp}</FilterChip>;
    });
    $[56] = tempFilters.temperature;
    $[57] = toggleTempFilterValue;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t30) {
    t31 = <div className="flex flex-wrap gap-2">{t30}</div>;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t29 || $[62] !== t31) {
    t32 = <div className="flex flex-col gap-3">{t29}{t31}</div>;
    $[61] = t29;
    $[62] = t31;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Separator />;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className="flex items-center gap-2"><FeatherAlertCircle className="text-brand-600 h-4 w-4" /><span className="text-body-bold font-body-bold text-default-font">Pendências</span></div>;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== toggleSelectAll) {
    t35 = () => toggleSelectAll("pendency", pendencyOptions);
    $[66] = toggleSelectAll;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  const t36 = buildSelectAllLabel(tempFilters.pendency.length, pendencyOptions.length);
  let t37;
  if ($[68] !== t35 || $[69] !== t36) {
    t37 = <div className="flex items-center justify-between">{t34}<Button variant="neutral-tertiary" size="small" onClick={t35}>{t36}</Button></div>;
    $[68] = t35;
    $[69] = t36;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== tempFilters.pendency || $[72] !== toggleTempFilterValue) {
    t38 = pendencyOptions.map(pend => <FilterChip key={pend} active={tempFilters.pendency.includes(pend)} onClick={() => toggleTempFilterValue("pendency", pend)}>{pend}</FilterChip>);
    $[71] = tempFilters.pendency;
    $[72] = toggleTempFilterValue;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[74] !== t38) {
    t39 = <div className="flex flex-wrap gap-2">{t38}</div>;
    $[74] = t38;
    $[75] = t39;
  } else {
    t39 = $[75];
  }
  let t40;
  if ($[76] !== t37 || $[77] !== t39) {
    t40 = <div className="flex flex-col gap-3">{t37}{t39}</div>;
    $[76] = t37;
    $[77] = t39;
    $[78] = t40;
  } else {
    t40 = $[78];
  }
  let t41;
  if ($[79] !== t15 || $[80] !== t24 || $[81] !== t32 || $[82] !== t40 || $[83] !== t8) {
    t41 = <div className="flex flex-1 flex-col gap-6 overflow-y-auto p-6 pb-32">{t8}{t15}{t16}{t24}{t25}{t32}{t33}{t40}</div>;
    $[79] = t15;
    $[80] = t24;
    $[81] = t32;
    $[82] = t40;
    $[83] = t8;
    $[84] = t41;
  } else {
    t41 = $[84];
  }
  const t42 = !hasTempFilters;
  let t43;
  if ($[85] !== clearTempFilters || $[86] !== t42) {
    t43 = <Button variant="neutral-secondary" size="large" className="flex-1" onClick={clearTempFilters} disabled={t42}>Limpar filtros</Button>;
    $[85] = clearTempFilters;
    $[86] = t42;
    $[87] = t43;
  } else {
    t43 = $[87];
  }
  let t44;
  if ($[88] !== applyFilters) {
    t44 = <Button variant="brand-primary" size="large" className="flex-1" onClick={applyFilters}>Aplicar filtros</Button>;
    $[88] = applyFilters;
    $[89] = t44;
  } else {
    t44 = $[89];
  }
  let t45;
  if ($[90] !== t43 || $[91] !== t44) {
    t45 = <div className="absolute right-0 bottom-0 left-0 flex items-center gap-3 border-t border-neutral-200 bg-white px-6 py-4 shadow-lg">{t43}{t44}</div>;
    $[90] = t43;
    $[91] = t44;
    $[92] = t45;
  } else {
    t45 = $[92];
  }
  let t46;
  if ($[93] !== t41 || $[94] !== t45 || $[95] !== t7) {
    t46 = <Drawer.Content className="animate-slide-in-right h-full w-full bg-white shadow-xl sm:w-[500px] lg:w-[600px]"><div className="relative flex h-full w-full flex-col">{t7}{t41}{t45}</div></Drawer.Content>;
    $[93] = t41;
    $[94] = t45;
    $[95] = t7;
    $[96] = t46;
  } else {
    t46 = $[96];
  }
  let t47;
  if ($[97] !== isOpen || $[98] !== onOpenChange || $[99] !== t46) {
    t47 = <Drawer open={isOpen} onOpenChange={onOpenChange} className="bg-transparent p-0">{t46}</Drawer>;
    $[97] = isOpen;
    $[98] = onOpenChange;
    $[99] = t46;
    $[100] = t47;
  } else {
    t47 = $[100];
  }
  return t47;
}
function _temp3(s) {
  return s.id;
}
function _temp2(selected, total) {
  return selected === total ? "Desmarcar" : "Selecionar todos";
}
function _temp(temperature) {
  const meta = getTemperatureMeta(temperature);
  if (meta.iconType === "flame") {
    return <FeatherFlame className="h-4 w-4" />;
  }
  if (meta.iconType === "thermometer") {
    return <FeatherThermometer className="h-4 w-4" />;
  }
  return <FeatherSnowflake className="h-4 w-4" />;
}